<div class="host-operate-sidebar v4-layout-drawer" [ngSwitch]="type">
  <host-operate-hostex-sidebar *ngSwitchCase="'hostex'"></host-operate-hostex-sidebar>

  <host-operate-channel-sidebar *ngSwitchCase="'channel'"></host-operate-channel-sidebar>

  <host-operate-hour-reservation-sidebar *ngSwitchCase="'hour-reservation'"></host-operate-hour-reservation-sidebar>
</div>
